import { render } from "./DangerIcon.vue?vue&type=template&id=d50d08a4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DangerIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d50d08a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d50d08a4', __exports__)) {
    api.reload('d50d08a4', __exports__)
  }
  
  module.hot.accept("./DangerIcon.vue?vue&type=template&id=d50d08a4", () => {
    api.rerender('d50d08a4', render)
  })

}


export default __exports__